import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {
  configure,
  searchBox,
  infiniteHits,
} from 'instantsearch.js/es/widgets';
import { isScannerQuery } from '@js/algolia/queryFilter.js';

/**
 * Alpine component for global search using Algolia InstantSearch
 * Lazy-initialized on first user interaction to reduce API calls
 */
export default function GlobalSearch() {
  return {
    search: null,
    initialized: false,
    debounceTimer: null,
    debounceMs: 350,
    minLength: 2,

    init() {},

    initSearch() {
      if (this.initialized) return;
      this.initialized = true;

      console.log('[GlobalSearch] Initializing Algolia on first interaction');

      const config = window.algoliaConfig;
      if (!config?.app_id || !config?.api_key) {
        console.warn('Algolia config not found');
        return;
      }

      const searchClient = algoliasearch(config.app_id, config.api_key);

      this.search = instantsearch({
        indexName: config.indices?.globalSearch || 'dev_globalSearch',
        searchClient,
      });

      const self = this;

      this.search.addWidgets([
        configure({ hitsPerPage: 5 }),
        searchBox({
          container: '#searchbox',
          placeholder: this.$el.dataset.textSearchPlaceholder || 'Search...',
          showReset: false,
          showSubmit: false,
          cssClasses: {
            input: 'focus:outline-none focus:ring-0 w-full',
          },
          queryHook(query, search) {
            clearTimeout(self.debounceTimer);
            if (isScannerQuery(query)) return;
            if (query.length === 0 || query.length >= self.minLength) {
              self.debounceTimer = setTimeout(
                () => search(query),
                self.debounceMs,
              );
            }
          },
        }),
        infiniteHits({
          container: '#hits',
          templates: {
            item: (hit) => `
              <div class="p-4 border-b hover:bg-gray-50 transition">
                <a href="${hit.url}" class="text-gray-700 font-semibold hover:underline">
                  ${hit.title}
                </a>
              </div>
            `,
          },
        }),
      ]);

      this.search.start();

      // Swap placeholder for Algolia's input
      const container = document.getElementById('searchbox');
      container?.querySelector('[data-search-placeholder]')?.remove();
      container?.querySelector('.ais-SearchBox-input')?.focus();
    },

    destroy() {
      clearTimeout(this.debounceTimer);
      if (this.search) {
        this.search.dispose();
      }
    },
  };
}
